/**
 * File: authDashboardController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class AuthDashboardController {
    // @ngInject
    constructor($scope, $rootScope, AUTHDASHCONSTANT, authService, localStorageService, $state, menuHeaderService, randomColorService) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Courseware"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => {
            $scope.loading = ""
            acdYear = "";
            userId = ""
            personData = ""
            featuresList = []
            url = ""
            $scope.myBookmarkList = []
            $scope.classCurriculumDetails = []
        }
        $scope.loading = true
        $scope.classCurriculumDetails = []
        let acdYear = localStorageService.get('academic_year');
        let userId = localStorageService.get('user_id');
        let schoolId = localStorageService.get("school_id")
        let personData
        let featuresList = []
        var url = AUTHDASHCONSTANT.AUTH_DASH_URL + "/" + userId + "/" + acdYear

        menuHeaderService.exitFromAuthoring()

        /*************** ALPHANUMERIC SORTING ********************/
        function normalizeMixedDataValue(value) {
            var padding = "000000000000000";
            // Loop over all numeric values in the string and
            // replace them with a value of a fixed-width for
            // both leading (integer) and trailing (decimal)
            // padded zeroes.
            value = value.replace(
                /(\d+)((\.\d+)+)?/g,
                function($0, integer, decimal, $3) {
                    // If this numeric value has "multiple"
                    // decimal portions, then the complexity
                    // is too high for this simple approach -
                    // just return the padded integer.
                    if (decimal !== $3) {
                        return (
                            padding.slice(integer.length) +
                            integer +
                            decimal
                        );

                    }
                    decimal = (decimal || ".0");
                    return (
                        padding.slice(integer.length) +
                        integer +
                        decimal +
                        padding.slice(decimal.length)
                    );
                }
            );
            return (value);
        }

        function sortByAlaphaNumeric(array, key) {
            array.sort(
                function(a, b) {
                    // Normalize the file names with fixed-
                    // width numeric data.
                    var aMixed = normalizeMixedDataValue(a[key]);
                    var bMixed = normalizeMixedDataValue(b[key]);
                    return (aMixed < bMixed ? -1 : 1);
                }
            );
            return array;
        }
        /*************** ALPHANUMERIC SORTING ********************/

        /*
         * Function to set dashboard
         * Developer : Arul Mozhi J
         */
        var setDashboard = () => {
                authService.callAPI(url, "GET", undefined, function(response) {
                    if (response) {
                        let result = response.result.data;
                        $scope.myBookmarkList = result.bookmarks;
                        personData = result.person;
                        if (result.person.courseware.length > 0) {
                            _.each(result.person.courseware, function(eachItem) {
                                let isPresent = false;
                                if (eachItem.subject) {
                                    eachItem.class_sort_order = eachItem.class.name + eachItem.batch.name
                                    if (featuresList && featuresList.length > 0) {
                                        _.each(featuresList, function(item) {
                                            if (item.class._id == eachItem.class._id && item.session._id == eachItem.session._id &&
                                                item.curriculum._id == eachItem.curriculum._id && item.batch._id == eachItem.batch._id &&
                                                item.subject._id == eachItem.subject._id) {
                                                if (eachItem.assign_roles != undefined) {
                                                    if (eachItem.assign_roles.length > 0) {
                                                        item.assign_roles = _.union(eachItem.assign_roles, item.assign_roles);
                                                    }
                                                };
                                                isPresent = true;
                                            }
                                        })
                                    }
                                    if (!isPresent) {
                                        featuresList.push(eachItem)
                                    }
                                }
                            })
                        }
                        console.log(featuresList)
                        _.each(featuresList, function(ob) {
                                ob["school_id"] = localStorageService.get("school_id")
                                let bookmarkList = _.filter($scope.myBookmarkList, function(bookmark) {
                                    return (bookmark.academic_details.session_id === ob.session._id &&
                                        bookmark.academic_details.curriculum_id === ob.curriculum._id &&
                                        bookmark.academic_details.school_id === ob.school_id &&
                                        bookmark.academic_details.class_id === ob.class._id &&
                                        bookmark.academic_details.batch_id === ob.batch._id &&
                                        bookmark.academic_details.subject_id === ob.subject._id)
                                })
                                if (bookmarkList.length > 0) {
                                    console.log("bookmark present")
                                    let pinnedBookmarkList = _.filter(bookmarkList, function(bookmark) {
                                        return bookmark.is_pinned_to_courseware;
                                    })
                                    if (pinnedBookmarkList.length > 0) {
                                        console.log("bookmark pinner")
                                        ob['bookmarkItems'] = pinnedBookmarkList
                                    } else {
                                        if (bookmarkList.length > 5) {
                                            console.log("bookmarkmore than 5")
                                            pinnedBookmarkList = _.last(_.sortBy(bookmarkList, 'audit_log.created_date'), 5);
                                            ob['bookmarkItems'] = pinnedBookmarkList
                                        } else {
                                            console.log(bookmarkList)
                                            ob['bookmarkItems'] = bookmarkList
                                        }
                                    }
                                    ob["isShowBookmark"] = true;
                                } else {
                                    ob['bookmarkItems'] = []
                                    ob["isShowBookmark"] = false;
                                }
                                ob["color"] = randomColorService.getRandomColor()
                            })
                            // grouping crurriculum/session/class/bath
                        let classCurriculumDetails = []
                        featuresList = sortByAlaphaNumeric(featuresList, 'class_sort_order')
                        _.each(_.groupBy(featuresList, function(eachFeature) {
                            return eachFeature.curriculum.name + '/' + eachFeature.session.name
                        }), function(featureArray, curriculumSession) {
                            let classBatchObj = []
                            _.each(_.groupBy(featureArray, function(each) {
                                return each.class.name + each.batch.name
                            }), function(eachArray, classBatchName) {
                                let obj = {
                                    classBatch: classBatchName
                                }
                                obj['classBatchValue'] = eachArray
                                classBatchObj.push(obj)
                            })
                            classCurriculumDetails.push({
                                curriculumSession: curriculumSession,
                                curriculumSessionValue: classBatchObj
                            })
                        })
                        $scope.classCurriculumDetails = classCurriculumDetails
                        $scope.loading = false
                        _.defer(() => {
                            $scope.$apply();
                        })
                    }
                })
            }
            //To set Previlege
        var prev = localStorageService.get("module_privileges")
        if (prev && prev.length > 0) {
            if (prev.findIndex(module => module.state === "authdashboard") === -1) {
                $state.go('dashboard')
            } else {
                setDashboard();
            }
        }

        // UserPrivilages.getUserPrivilageInitialSetting(function (result) {
        //     if (result.module_privileges && result.module_privileges.length > 0) {
        //         if (result.module_privileges.findIndex(module => module.state === "authdashboard") === -1) {
        //             $state.go('dashboard')
        //         } else {
        //             $scope.loading = false
        //             setDashboard();
        //         }
        //     }
        // })


        /*
         * Function to goto Teaching plan
         * Developer : Arul Mozhi J
         */
        $scope.gotoTeachingPlan = () => {
            $state.go('newTeachingPlan')
        }

        /*
         * Function to goto bookmark page
         * @bookmark : Object - bookmark details
         * @return : boolean - success or fail
         * Developer : Arul Mozhi J
         */
        $scope.gotoBookmark = (bookmark, e) => {
            _.each(bookmark.session_details, function(sessionData) {
                localStorageService.set(sessionData.key, sessionData.value)
            })
            $state.go(bookmark.state_details.name, bookmark.state_details.params)
            e.stopPropagation()
        }

        /*
         * Function to goto authoring tool
         * @data : Object - courseware details
         * Developer : Arul Mozhi J
         */
        $scope.routeToMainPage = (data) => {

            // try {
            //     let tincanData = {
            //         actor: {
            //             "mbox": "mailto:" + Meteor.user().username,
            //             "account": {
            //                 "name": Meteor.user().name,
            //                 "homePage": SITE_URL
            //             },
            //             "objectType": "Agent"
            //         },
            //         verb: {
            //             id: SITE_URL + "expapi/verbs/interacted",
            //             display: {
            //                 "en-US": "clicked"
            //             }
            //         },
            //         object: {
            //             id: window.location.href,
            //             definition: {
            //                 type: SITE_URL + "authoringtool/subject",
            //                 name: {
            //                     "en-US": data.name
            //                 },
            //                 description: {
            //                     "en-US": "user selected subject " + data.name
            //                 }
            //             }
            //         }
            //     }

            //     TinCanApiService.sendTincanApiRequest(tincanData)

            // } catch (ex) {

            // }

            menuHeaderService.destroySession()
            localStorageService.set("authoringData", {
                class: data.class.name,
                batch: data.batch.name,
                curriculum: data.curriculum.name,
                curriculum_id: data.curriculum._id,
                session: data.session.name,
                subject: data.subject.name,
                class_id: data.class._id,
                batch_id: data.batch._id,
                session_id: data.session._id,
                subject_id: data.subject._id,
                role: data.assign_roles,
                academic_year: acdYear,
                currentUser: personData,
                currRoleId: personData.role_ids,
                school_id: schoolId
            })
            localStorageService.set('personData', personData)
            localStorageService.set('multiRoles', data.assign_roles)
            menuHeaderService.setDefault()
            $state.go('authoringTool')
        }
    }
}

export default AuthDashboardController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/controllers/authDashboardController.js